import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  section: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    margin: '12px 0'
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  subtitle: {
    color: theme.palette.grey[600],
    fontSize: 13,
    fontWeight: 500,
    marginTop: 4,
    marginBottom: theme.spacing(3)
  },
  sectionTitle: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    marginBottom: theme.spacing(2)
  },
  overrideHelp: {
    color: theme.palette.grey[600],
    fontSize: 13,
    marginTop: -theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  inputs: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(240px, 320px))',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  input: {
    width: '100%'
  },
  operations: {
    display: 'grid',
    gap: theme.spacing(2)
  },
  operation: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(2)
  },
  operationHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column'
    }
  },
  operationName: {
    color: theme.palette.text.primary,
    fontWeight: 600
  },
  metadata: {
    color: theme.palette.grey[600],
    marginTop: theme.spacing(2),
    overflowWrap: 'anywhere',
    textAlign: 'right'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3)
  },
  saveButton: {
    marginLeft: theme.spacing(1)
  },
  buttonText: {
    fontWeight: 500
  },
  whiteText: {
    color: theme.palette.background.default,
    fontWeight: 500
  },
  progress: {
    marginLeft: theme.spacing(1),
    color: theme.palette.background.default
  }
}))

export default useStyles
